import React from 'react';
import logo from '../../../../../assets/images/logo_cp.png';
import moment from 'moment';
import 'moment/locale/es';

const nombreUsuario = sessionStorage.getItem('nombre');
const apellidoUsuario = sessionStorage.getItem('apellido');

export const TemplatePresupuestoCP = ({ presupuesto = {} }) => {
    return (
        <div
            id='content-presupuesto-cp'
            style={{
                fontFamily: 'Arial, sans-serif',
                padding: 30,
                paddingTop: 10,
                background: 'white',
                width: '150mm',
                boxSizing: 'border-box',
                fontSize: 9.5,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <img
                    src={logo}
                    alt='Logo Nutrihome'
                    style={{ width: 170, height: 45 }}
                />
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <p>{!!presupuesto.dia ? `${presupuesto.dia} de ${presupuesto.mes} de ${presupuesto.anio}` : ''}</p>
            </div>
            <div>
                <a style={{
                    color: 'black',
                    padding: 0,
                    textDecoration: 'underline'
                }} href='#'>Cliente: </a> <a style={{
                    color: 'black',
                    padding: 0,
                }}> {presupuesto.razonSocial} </a>
            </div>
            <br />
            <div>
                <a style={{
                    color: 'black',
                    padding: 0,
                    textDecoration: 'underline'
                }} href='#'>Presente</a>
            </div>

            <div style={{ marginRight: 40, fontSize: 9 }}>
                <p style={{ textIndent: '40px', marginBottom: 5 }}>Por medio de la presente hago llegar a Ud. el presupuesto por el {presupuesto.modulo}, correspondiente al paciente
                    {presupuesto.paciente} <strong>Af. {presupuesto.numeroAfiliado}.</strong>
                </p>
                <p style={{ textIndent: '40px', marginTop: 0 }}>El servicio se brindará en el domicilio dispuesto por la familia del mencionado
                    paciente sito en {presupuesto.direccionPaciente} y corresponde al período <strong>{presupuesto.periodo}</strong>
                </p>
            </div>
            <div style={{ marginTop: 30 }}>
                <p style={{ textDecoration: 'underline', textIndent: '40px', fontWeight: 'bold' }}>Programa de cuidados paliativos</p>
                <u>Composición de la prestación:</u>

                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas médicas: {presupuesto.visitaMedica}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas enfermeria: {presupuesto.visitaEnfermeria}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas kinesiologia: {presupuesto.visitaKinesiologia}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas psicologo: {presupuesto.visitaPsicologo}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas guardia: {presupuesto.visitaGuardia}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas psiquiatra: {presupuesto.visitaPsiquiatra}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas terapista ocupacional: {presupuesto.visitaTerapista}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Visitas asistente social: {presupuesto.visitaAsistente}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Insumos: {presupuesto.articulos}</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Logística, transporte y distribución de insumos</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Opioides: preparados magistrales de morfina, oxicodona, metadona y Morfina en ampollas.</p>
                <p style={{ lineHeight: '12px', fontSize: '9.5px', textIndent: 34, margin: 0 }}>-Asesoría telefónica las 24hs</p>

                <div>
                    <p>
                        Precio del modulo: ${presupuesto.precioDiario} por día de prestación
                    </p>
                    <div style={{ marginLeft: 20 }}>
                        <p style={{ margin: 0, lineHeight: '16px' }}>· El precio del módulo <strong><u>NO</u></strong> incluye <strong>IVA</strong>.</p>
                        <p style={{ margin: 0, lineHeight: '16px' }}>· <strong>Condición de pago: 30 días de fecha de presentación de la factura.</strong></p>
                        <strong style={{ lineHeight: '16px', textTransform: 'uppercase' }}>En caso de requerir el mencionado servicio, por favor solicitamos:</strong>
                        <p style={{ margin: 0, lineHeight: '16px' }}>- Nos envíen la autorización por mail a <strong>consultas@carehome.com.ar</strong></p>
                        <p style={{ margin: 0, lineHeight: '16px' }}>
                            - Se establezca la condición del Paciente ante el IVA.
                        </p>
                        <p style={{ margin: 0, lineHeight: '16px' }}>
                            - Copia de Inscripción / CUIT
                        </p>
                    </div>
                </div>
            </div>
            <div style={{ color: '#0000FF', marginTop: 100, width: '100%', display: 'flex', flexDirection: 'column' }}>
                <div style={{ width: '100%', borderBottom: '1px solid', paddingBottom: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', }}>
                        <p style={{ margin: 0 }} >{apellidoUsuario}, {nombreUsuario}</p>
                        <p style={{ margin: 0 }} >Cuidados Paliativos | Nutrihome S.A.</p>
                        <p style={{ margin: 0 }} ><u>{nombreUsuario}</u></p>
                        <p style={{ margin: 0 }} >
                            <a style={{ padding: 0, color: '#0000FF', textDecoration: 'underline' }} href='http://www.carehome.com.ar'>
                                http://www.carehome.com.ar
                            </a>
                        </p>
                    </div>
                </div>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <div>
                        <p>Delegación {presupuesto.delegacion}</p>
                        <p><u>Tel: {presupuesto.delegacionTelefono}</u></p>
                    </div>
                    <div>
                        <p>{presupuesto.direccionDelegacion}</p>
                    </div>
                </div>
            </div>

        </div >

    )
}
